import React from "react"

import ProjectFinder from "../../../../gd-components/finder/project/project-finder"
import {EntityType} from "../../../../gd/const/item"
import {moveTaskToProjectViaPopover} from "../../../../gd-modals/move-to/move"
import Task from "../../../../model2/task/task"

type Props = {
    hidePopover : func
    menuParams  : {
        task        : Task
        onMove?     : func
        hidePopover : func   // closes the whole "More" menu
    }
}

export default function TaskMore_MoveToProjectPopover(props: Props) {

    const onClickProject = (projectId: ID) => {
        const project = gd.session.projects.get(projectId)

        props.menuParams.hidePopover()

        if (project) {
            moveTaskToProjectViaPopover(props.menuParams.task, project, props.menuParams.onMove)
        }

        return
    }

    return (
        <ProjectFinder
            // keeps ancestor popovers (the "More" menu / "Move" submenu) open while
            // the tree is being searched/expanded -- their outside-click detection
            // (react-onclickoutside) treats this subtree as "inside"
            className       = "ignore-react-onclickoutside"
            noHeader        = {true}
            parentsFor      = {EntityType.TASK}
            parentProjectId = {props.menuParams.task.projectId}
            onClickProject  = {onClickProject}
            onClose         = {props.hidePopover}
        />
    )
}
